<template>
  <div>
    <h2>You need to login to use this website</h2>
    <b-button variant="primary" v-bind:href="loginURL" class="btn loginBtn">
      Login
    </b-button>
  </div>
</template>

<style scoped>
.loginBtn {
  background-color: #0076a8;
}
</style>

<script>
export default {
  name: "Login",
  data() {
    return {
      loginURL:
        process.env.VUE_APP_COGNITO_URL +
        window.location.origin +
        process.env.VUE_APP_LOGIN_REDIRECT_PATH,
    };
  },
};
</script>
